import { InfoIcon } from 'lucide-react';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Toggle } from '@/components/ui/toggle';
import { cn } from '@/lib/utils';

interface DetailsPanelToggleProps {
  pressed: boolean;
  onPressedChange: (next: boolean) => void;
  tooltip: string;
}

// Toggle has no icon-only size yet — overrides give it a square shape and a
// visible pressed-state, neither of which the text-tuned defaults provide.
export const DetailsPanelToggle = ({
  pressed,
  onPressedChange,
  tooltip,
}: DetailsPanelToggleProps) => (
  <InfoTooltip content={tooltip}>
    <Toggle
      pressed={pressed}
      onPressedChange={onPressedChange}
      size="sm"
      className={cn(
        'size-9 border px-0 data-[state=on]:border-informational data-[state=on]:bg-bg-info-soft data-[state=on]:text-informational',
        pressed
          ? 'border-informational bg-bg-info-soft text-informational hover:bg-bg-info-soft hover:text-informational'
          : 'border-stroke bg-background text-foreground-muted hover:bg-bg-muted hover:text-foreground-muted'
      )}
    >
      <InfoIcon size={16} />
      <span className="sr-only">{tooltip}</span>
    </Toggle>
  </InfoTooltip>
);
